import React, { Component } from 'react'
import "./css/clock.css";

import moment from 'moment';
export default class Clock extends Component {
    constructor(){
        super();
        this.state={
          time: moment().format('LTS'),
          one: true,
          two: false,
          three: false,
          four: false,
          background: {
            backgroundColor: "#000000".replace(/0/g,function(){return (~~(Math.random()*16)).toString(16)})
          }
          
        }
        this.clicked = this.clicked.bind(this);
        this._isMounted = false;
      }
    componentDidMount() {
      this._isMounted = true;
      this._isMounted = true && setInterval(()=>{
        if(this.state.one === true) {
          this.setState({
            time: moment().format('LTS')
          })
        }
        else if(this.state.four === true){
          this.setState({
            time: moment().format('LT')
          })
        }
      },1000);
    }
    clicked(){
        this.setState({
          background: {
            backgroundColor: "#000000".replace(/0/g,function(){return (~~(Math.random()*16)).toString(16)})
          }
        })
        if(this.state.one === true) {
          setTimeout(()=>{
            this.setState({
              time: moment().format('l'),
              one: false,
              two: true
            })
          },200)
        }
        else if(this.state.two === true) {
          setTimeout(()=>{
            this.setState({
              time: moment().format('MMMM Do YY'),
              two: false,
              three: true
            })
          },200)
        }
        else if(this.state.three === true) {
          setTimeout(()=>{
            this.setState({
              time: moment().format('LT'),
              three: false,
              four: true
            })
          },200)
        }
        else if(this.state.four === true) {
          setTimeout(()=>{
            this.setState({
              time: moment().format('LTS'),
              four: false,
              one: true
            })
          },200)
        }
      }
    componentWillUnmount() {
       this._isMounted = false;
     }
    render() {
        
        return (
          <>
            
            <p id="instruction">Click anywhere to change formats</p>
            <div className="clock-body" style={this.state.background} onClick={this.clicked}>
				      <h1 className="clock">{this.state.time}</h1>
			      </div>
          </>
            
        )
    }
}
